import { domLoaded } from '../util/domLoaded';

domLoaded(async () => 
{
    if (window.g2Data) {
        await (await import("./util/initBlog")).initBlog(window.g2Data);
    };
});
